import React, {lazy, Suspense} from "react";
import styled from "styled-components";
import {Fragment, useEffect, useState, useCallback} from "react";
import algoliasearch from 'algoliasearch/lite';
import ListSubheader from "@material-ui/core/ListSubheader";
import Firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import {useAuthState} from "react-firebase-hooks/auth";
import EmployeeListItem from "../../Common/Views/ListItems/EmployeeListItem";
import Employee, {isEmployee} from "../../Common/Models/Employee";
import QuickLink, {isQuickLink} from "../../Common/Models/QuickLink";
import QuickLinkListItem from "../../Common/Views/ListItems/QuickLinkListItem";
import ListItemsType from "../../Common/Models/ListItemsType";
import ItemType from "../../Common/Models/ItemType";
import toggleFavorite from "../../Common/Helper/toggleFavorite";
import triggerHaptics from "../../Common/Helper/triggerHaptics";
import useFavorites from "../../Common/Context/Consumers/useFavorites";
import openWebPage from "../../Common/Helper/openWebPage";
import SearchPageHeader from "./Views/SearchPageHeader";
import SearchPageBody from "./Views/SearchPageBody";
import SearchPageFooter from "./Views/SearchPageFooter";
import SearchPage from "./Views/SearchPage";
import useSearch from "../../Common/Context/Consumers/useSearch";
const EmployeePage = lazy(() => import("../../Common/Views/Modals/EmployeeModal/EmployeeModal"));
const client = algoliasearch('4HZF9PBKRR', 'c640f05f68c6139382661aabde2c8b74');

const ListTitleHeader = styled.div`
  font-size: 1.10rem;
`
export const SearchPageController = (props: any) => {

    const {open, dismiss} = props;
    const [results, setResults] = useState<any>({});
    const [user] = useAuthState(Firebase.auth());
    const [employee, selectEmployee] = useState<any>();
    const {query}: any = useSearch();
    const favorites: any = useFavorites();
    let item;

    const queries = [{
            query,
            indexName: 'portal_app_services',
            hitsPerPage: 10
        },
        {
            query,
            indexName: 'dev_MC_Employees',
            hitsPerPage: 19,
        },
    ];

    const search = useCallback(() => {

        //@ts-ignore
        client.multipleQueries(queries).then(({results}: any) => {
            let finalResults: any = {};
            let n = 0;
            results.forEach((index: any) => {

                if(index.hits.length > 0) {
                    const title = queries[n].indexName;
                    finalResults[title] = index.hits;
                }
                n++;
            });
            setResults(finalResults);

        }).catch((error:Error) => {

        });
    }, [queries])

    useEffect(() => {
        // @ts-ignore
        search();
    }, [query]);

    const getTitle = (t: string): string => {
        const titles: any = {
            'dev_MC_Employees': 'Employees',
            'portal_app_services': 'Quick Links'
        };
        return titles[t];
    };

    const listItemOnClick = (item: ListItemsType) => {
        switch (true) {
            case isEmployee(item):
                selectEmployee(item as Employee);
                break;
            case isQuickLink(item):
                openWebPage((item as QuickLink).URL);
                break;
            default:
                break;
        }
    };

    const onClickFavorite = (id: string, searchType: ItemType) => {
        toggleFavorite(id, searchType, favorites, user.uid);
        triggerHaptics();
    };

    const employeePageDismiss = () => {
            selectEmployee(undefined);
    };

    const displaySearchResults = () => {
        let title: string;
        let result: any[];
        return Object.entries(results).map((section: any) => {
            title = getTitle(section[0]);
            result = section[1];
            return (
                <Fragment key={title}>
                    <ListSubheader
                        disableSticky
                        component={'li'}
                        key={title + 'title'}
                    >
                        <ListTitleHeader>{title}</ListTitleHeader>
                    </ListSubheader>
                    {
                        result.map((data: any) => {
                            switch(title) {
                                case 'Employees':
                                    const {
                                        EMPL_FULL_NAME,
                                        EMPL_EMAIL,
                                        EMPL_OFFICE_FTELE,
                                        EMPL_OFFICE,
                                        TITLEDEPT,
                                        TITLEDEPT_2,
                                        imgurl,
                                        imgurl_thumbnail,
                                    } = data;
                                    item = {
                                        id: data.objectID,
                                        fullName: EMPL_FULL_NAME,
                                        email: EMPL_EMAIL,
                                        phone: EMPL_OFFICE_FTELE,
                                        location: EMPL_OFFICE,
                                        title: TITLEDEPT,
                                        title_2: TITLEDEPT_2,
                                        imageURL: imgurl.replace("http", "https"),
                                        imageThumbnailURL: imgurl_thumbnail.replace("http", "https")
                                    } as Employee;
                                    return <EmployeeListItem
                                        key={data.objectID}
                                        item={item}
                                        displayFavorite={user}
                                        isFavorite={favorites.Employees ? favorites.Employees[item.id] : false}
                                        onClick={listItemOnClick}
                                        onClickFavorite={onClickFavorite}
                                    />;
                                case 'Quick Links':
                                    const {URL, Title} = data;
                                    const iconURL = data["Icon URL"];
                                    item = {
                                        id: data.objectID,
                                        title: Title,
                                        URL: URL,
                                        iconURL: iconURL,
                                    } as QuickLink;

                                    return <QuickLinkListItem
                                        key={data.objectID}
                                        item={item}
                                        displayFavorite={user}
                                        isFavorite={favorites["Quick Links"] ? favorites["Quick Links"][item.id] : false}
                                        onClick={listItemOnClick}
                                        onClickFavorite={onClickFavorite}
                                    />;
                                default:
                                    break;
                            }
                        })
                    }
                </Fragment>
            );

        });
    };

    return(
        <>
        <SearchPage
            open={open}
            dismiss={dismiss}
        >
            <SearchPageHeader />
            <SearchPageBody>
                {displaySearchResults()}
            </SearchPageBody>
            <SearchPageFooter dismiss={dismiss} />
        </SearchPage>

        <Suspense fallback={(() => <></>)()}>
            <EmployeePage
                open={!!employee}
                dismiss={employeePageDismiss}
                employee={employee}
            />
        </Suspense>

      </>
    );
};